module.exports = __webpack_public_path__ + "static/media/Averta_Demo_PE.e12fc350.otf";